module.exports = __webpack_public_path__ + "img/title3.1e8c5c63.png";